import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ShippingAddress from '../../CheckoutProcess/components/fields/ShippingAddress';
import { PaymentContext } from '../contexts/PaymentContext';
import CreditCards from './CreditCards';

class SquarePaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      googlePay: false,
      applePay: false,
      masterpass: false,
      cardToken: undefined,
      token: '',
      number: '',
      expMonth: '',
      expYear: '',
      ccv: '',
      zip: '',
      cardType: '',
      walletType: '',
      address: {
        name: this.props.name,
        address: this.props.defaultAddress.address,
        address2: this.props.defaultAddress.address2,
        city: this.props.defaultAddress.city,
        state: this.props.defaultAddress.state,
        country: this.props.defaultAddress.country,
        zip: this.props.defaultAddress.zip,
        phone: this.props.phone,
      },
      useDeliveryAddress: true,
      squareLoaded: false,
      paymentLoading: false,
      errors: [],
    };
    this.requestCardNonce = this.requestCardNonce.bind(this);
    this.changeZip = this.changeZip.bind(this);
    this.toggleZip = this.toggleZip.bind(this);
    this.processPay = this.processPay.bind(this);
    this.sqPayments = null;
    this.card = null;
    this.googlePay = null;
    this.applePay = null;
  }

  componentDidMount() {
    this.toggleZip(this.props.defaultAddress.country);
    this.sqPayments = this.props.sqPayments(this.props.applicationId, this.props.locationId);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;
    this.sqPayments.card({}).then(function (card) {
      card.attach('#card-container');
      that.card = card;
      that.setState({ squareLoaded: true });
      setTimeout(() => {
        card.focus('cardNumber');
      }, 500);
    });

    const paymentRequest = this.sqPayments.paymentRequest({
      countryCode: this.props.country,
      currencyCode: this.props.currency,
      requestBillingContact: true,
      requestShippingContact: true,
      total: {
        amount: (this.props.amount / 100).toString(),
        label: 'Total',
      },
    });

    // Add Apple Pay and Google Pay buttons
    this.sqPayments.googlePay(paymentRequest).then(function (googlePay) {
      that.googlePay = googlePay;
      that.setState({ googlePay: googlePay });
    });

    this.sqPayments.applePay(paymentRequest).then(function (applePay) {
      that.applePay = applePay;
      that.setState({ applePay: applePay });
    });

    const googlePayButton = document.getElementById('sq-google-pay');
    googlePayButton.addEventListener('click', async function (event) {
      event.preventDefault();
      that.googlePay.tokenize().then(function (tokenResult) {
        that.processPay(tokenResult);
      });
    });

    const applePayButton = document.getElementById('sq-apple-pay');
    applePayButton.addEventListener('click', async function (event) {
      event.preventDefault();
      that.applePay.tokenize().then(function (tokenResult) {
        that.processPay(tokenResult);
      });
    });
  }

  processPay = (tokenResult) => {
    // Validate
    if (
      !tokenResult ||
      typeof tokenResult.details === 'undefined' ||
      typeof tokenResult.details.billing === 'undefined' ||
      typeof tokenResult.details.card === 'undefined' ||
      typeof tokenResult.token === 'undefined' ||
      typeof tokenResult.status === 'undefined' ||
      tokenResult.status !== 'OK'
    ) {
      this.props.onPaymentFail([{ detail: 'Unable to process payment' }]);
      return false;
    }

    var state = {
      cardToken: tokenResult.token,
    };

    // Fill the card data
    state.number = tokenResult.details.card.last4;
    state.cardType = tokenResult.details.card.brand;
    state.expMonth = tokenResult.details.card.expMonth;
    state.expYear = tokenResult.details.card.expYear;

    // Fill the billing details
    let address = Object.assign({}, this.state.address);
    tokenResult.details.billing.givenName &&
      (address.name = tokenResult.details.billing.givenName + ' ' + tokenResult.details.billing.familyName);
    tokenResult.details.billing.addressLines.length >= 1 &&
      tokenResult.details.billing.addressLines[0].length &&
      (address.address = tokenResult.details.billing.addressLines[0]);
    tokenResult.details.billing.addressLines.length >= 2 &&
      tokenResult.details.billing.addressLines[1].length &&
      (address.address2 = tokenResult.details.billing.addressLines[1]);
    tokenResult.details.billing.city && (address.city = tokenResult.details.billing.city);
    tokenResult.details.billing.state && (address.state = tokenResult.details.billing.state);
    tokenResult.details.billing.postalCode && (address.zip = tokenResult.details.billing.postalCode);
    tokenResult.details.billing.countryCode && (address.country = tokenResult.details.billing.countryCode);
    tokenResult.details.billing.phone && (address.phone = tokenResult.details.billing.phone);
    state.address = address;

    this.setState(state);
    this.submitPayment(tokenResult.token, true);
  };

  requestCardNonce = (e) => {
    e.preventDefault();
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;

    if (this.state.paymentLoading === true) {
      return;
    } else {
      this.setState({ paymentLoading: true });
    }
    this.props.onPaymentInitiated();

    this.card.tokenize().then(function (tokenResult) {
      if (tokenResult.token) {
        // Update card type from tokenization result
        const cardBrand = tokenResult?.details?.card?.brand;
        if (cardBrand) {
          that.setState({ cardType: tokenResult.details.card.brand });
        }
        
        if (tokenResult.details && tokenResult.details.billing && tokenResult.details.billing.postalCode) {
          that.changeZip(tokenResult.details.billing.postalCode);
          that.submitPayment(tokenResult.token);
        } else {
          if (that.state.zip) {
            that.submitPayment(tokenResult.token);
          } else if (that.state.address.zip) {
            that.changeZip(that.state.address.zip);
            that.submitPayment(tokenResult.token);
          } else {
            document.getElementById('customer-zip').parentElement.style.display = 'inherit';
            that.fieldErrorShow(document.getElementById('customer-zip'), 'Please provide a ZIP code');
            that.setState({ paymentLoading: false });
            return false;
          }
        }
      } else {
        // we don't have a token
        that.fieldErrorShow(document.getElementById('card-container'), 'Unable to process payment');
        that.setState({ paymentLoading: false });
        return false;
      }
    });
  };

  onAddressChange = (address) => {
    this.toggleZip(address.country);
    this.setState({ address });
  };

  toggleZip = (country) => {
    let customer_zip = document.getElementById('customer-zip');
    if (!customer_zip) {
      return false;
    }
    if (['US', 'CA', 'UK', 'GB'].includes(country)) {
      customer_zip.parentElement.style.display = 'none';
    } else {
      customer_zip.parentElement.style.display = 'block';
    }
  };

  changeZip = (zip) => {
    let address = { ...this.state.address };
    address.zip = zip;
    this.setState({ zip: zip, address });
  };

  onUseDeliveryAddressChange = () => {
    this.setState({
      useDeliveryAddress: !this.state.useDeliveryAddress,
    });
  };

  onSuccess = () => {
    this.setState({ paymentLoading: false });
  };

  onError = () => {
    this.setState({ paymentLoading: false });
  };

  submitPayment = async (cardNonce = null, tosAccepted = null) => {
    if (this.props.isFullyPaid) {
      return;
    }

    let payload = {
      name: this.state.address.name,
      ...this.state.address,
      amount: this.props.amount,
      email: this.props.email,
      tos_accepted: tosAccepted ?? this.props.tosAccepted,
      captureMethod: this.props.captureMethod,
      emailOptOut: this.props.emailOptOut,
      // Always include these fields, even if empty, to match Listings
      number: '',
      expiration_month: '',
      expiration_year: '',
      security_code: '',
    };

    // For Square tokenized payments, include card_token and card_type
    if (cardNonce) {
      payload.card_token = cardNonce;
      payload.card_type = this.state.cardType;
    } else {
      // For non-tokenized payments, fill in card details
      payload.number = this.state.number.replace(/\s+/g, '');
      payload.expiration_month = this.state.expMonth;
      payload.expiration_year = this.state.expYear;
      payload.security_code = this.state.ccv;
    }

    if (this.props.createdNewAccount) {
      payload.sendAccountEmail = 1;
    }

    if (this.state.useDeliveryAddress) {
      this.props.setDeliveryAddress({ ...this.state.address });
    }

    if (!(await this.props.validateAndSaveDeliveryAddress(this.props.t))) {
      this.setState({ paymentLoading: false });
      return;
    }

    this.props.onPaymentSubmit(payload, { onSuccess: this.onSuccess, onError: this.onError });
  };

  clearErrors() {
    this.setState({ errors: [] });
    // Set default values for error element
    if (typeof document.getElementsByClassName('alert')[0] !== 'undefined') {
      document.getElementsByClassName('alert')[0].parentElement.style.position = '';
      document.getElementsByClassName('alert')[0].parentElement.style.top = '';
    }
  }

  renderErrors() {
    return this.state.errors.map((e, i) => {
      return (
        <div className="message__container message__container--error" key={i}>
          <p>{e.message}</p>
        </div>
      );
    });
  }

  fieldErrorShow = (field, error) => {
    Promise.resolve(this.props.onPaymentFail([{ detail: error }])).then(function () {
      field.focus();
      document.getElementsByClassName('alert')[0].parentElement.style.position = 'sticky';
      document.getElementsByClassName('alert')[0].parentElement.style.top = '0';
      document.getElementsByClassName('alert')[0].parentElement.style.zIndex = '1000';
    });
  };

  renderDeliveryAddress() {
    return this.props.deliveryOption.method_name === 'Mail' || this.props.hasDeliverableProducts ? (
      <ShippingAddress
        address={this.props.deliveryAddress}
        onAddressChange={this.props.setDeliveryAddress}
        useShippingAddress={this.state.useDeliveryAddress}
        onUseShippingAddressChange={this.onUseDeliveryAddressChange}
      />
    ) : (
      <div></div>
    );
  }

  render() {
    return (
      <PaymentContext.Consumer>
        {({ LocalizedAddress }) => (
          <section className="checkout-form__section">
            <div
              ref={(el) => {
                this.top = el;
              }}
            />
            <div className="row" style={{ textAlign: 'center', display: this.state.squareLoaded ? 'none' : 'inherit' }}>
              <span className="loader" style={{ fontSize: '50px' }}></span>
            </div>
            <form
              id="payment-submit-form"
              onSubmit={this.requestCardNonce}
              style={{ display: this.state.squareLoaded ? 'inherit' : 'none' }}
            >
              <div className="card__input-group">
                <div
                  id="sq-walletbox"
                  style={{
                    display: this.state.applePay || this.state.masterpass || this.state.googlePay ? 'inherit' : 'none',
                  }}
                >
                  <button
                    style={{ display: this.state.applePay ? 'inherit' : 'none' }}
                    className="wallet-button"
                    id="sq-apple-pay"
                  />
                  <button
                    style={{ display: this.state.masterpass ? 'inherit' : 'none' }}
                    className="wallet-button"
                    id="sq-masterpass"
                  />
                  <button
                    style={{ display: this.state.googlePay ? 'inherit' : 'none' }}
                    className="wallet-button"
                    id="sq-google-pay"
                  />
                </div>
                <h4 className="checkout-form__sub-heading checkout-form__credit-card__sub-heading">
                  <div className="flex-left">{this.props.t.t('checkout__credit_card_details')}</div>
                  <div className="flex-right">
                    <CreditCards acceptedCards={this.props.acceptedCards} />
                  </div>
                </h4>

                <div id="card-container" tabIndex="0"></div>

                {!!this.state.errors.length && <div className="cart__footer-actions">{this.renderErrors()}</div>}

                <LocalizedAddress
                  {...this.state.address}
                  onAddressChange={this.onAddressChange}
                  toggleZip={this.toggleZip}
                  header={this.props.t.t('checkout__billing_address')}
                  ref={(el) => {
                    this.messagesEnd = el;
                  }}
                />
                {this.renderDeliveryAddress()}
                <button
                  style={{ display: 'none' }}
                  id="payment-form-invisible-button"
                  type="submit"
                  onClick={this.requestCardNonce}
                >
                  {this.props.t.t('checkout__pay_now')}
                </button>
              </div>
            </form>
          </section>
        )}
      </PaymentContext.Consumer>
    );
  }
}

SquarePaymentForm.propTypes = {
  onPaymentInitiated: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  onPaymentFail: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phone: PropTypes.string,
  token: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  acceptedCards: PropTypes.object,
  captureMethod: PropTypes.number,
  isFullyPaid: PropTypes.bool,
  createdNewAccount: PropTypes.bool,
  emailOptOut: PropTypes.bool,
  applicationId: PropTypes.string.isRequired,
  locationId: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  validateAndSaveDeliveryAddress: PropTypes.func.isRequired,
  setDeliveryAddress: PropTypes.func.isRequired,
  deliveryAddress: PropTypes.object.isRequired,
  deliveryOption: PropTypes.object,
  defaultAddress: PropTypes.object,
};

SquarePaymentForm.defaultProps = {
  phone: '',
  name: '',
  acceptedCards: {},
  captureMethod: 1, // CAPTURE_ONLINE
  defaultAddress: {},
};

export default SquarePaymentForm;
